import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";

export const TAB = {
  LOAN: "loan",
  LOAN_INSTALLMENT: "loan_installment",
  EXTENSION: "extension",
};

export const initCampaignFilter = {
  name: "",
  page: 1,
  pageSize: 10,
  sortingField: null,
  sortingOrder: null,
  outlets: [],
};

export const renderColumns = (handleEdit, handleDelete) => {
  return [
    {
      dataIndex: "campaignName",
      key: "campaignName",
      title: "Nama Promo",
      backend_key: "name",
      sorter: true,
      width: "10%",
    },
    {
      dataIndex: "outlet",
      key: "outlet",
      title: "Outlet",
      width: "7%",
    },
    {
      dataIndex: "category",
      key: "category",
      title: "Kategori Produk",
      width: "7%",
    },
    {
      dataIndex: "paymentType",
      key: "paymentType",
      title: "Jenis Pembayaran",
      width: "6%",
    },
    {
      dataIndex: "tenorType",
      key: "tenorType",
      title: "Jenis Tenor",
      width: "5%",
    },
    {
      dataIndex: "tenorPerLoan",
      key: "tenorPerLoan",
      title: "Tenor Per Pinjaman",
      width: "5%",
    },
    {
      dataIndex: "maxExtension",
      key: "maxExtension",
      title: "Maksimum Perpanjangan",
      width: "6%",
    },
    {
      dataIndex: "maxLate",
      key: "maxLate",
      title: "Maksimum Keterlambatan",
      width: "5%",
    },
    {
      dataIndex: "totalTenor",
      key: "totalTenor",
      title: "Total Tenor",
      width: "5%",
    },
    {
      dataIndex: "minLoan",
      key: "minLoan",
      title: "Minimum Pinjaman",
      width: "5%",
    },
    {
      dataIndex: "maxLoan",
      key: "maxLoan",
      title: "Loan to Value",
      width: "5%",
    },
    {
      dataIndex: "capitalLoan",
      key: "capitalLoan",
      title: "Biaya Sewa Modal",
      width: "5%",
    },
    {
      dataIndex: "feeAdminPercent",
      key: "feeAdminPercent",
      title: "Biaya Admin (%)",
      width: "5%",
    },
    {
      dataIndex: "feeAdminRupiah",
      key: "feeAdminRupiah",
      title: "Biaya Admin (Rp)",
      width: "5%",
    },
    {
      dataIndex: "feeSavingInsurance",
      key: "feeSavingInsurance",
      title: "Biaya Simpan & Asuransi",
      width: "6%",
    },
    {
      dataIndex: "lateCharge",
      key: "lateCharge",
      title: "Biaya Keterlambatan",
      width: "5%",
    },
    {
      dataIndex: "feeAuction",
      key: "feeAuction",
      title: "Biaya Jasa Lelang",
      width: "5%",
    },
    {
      dataIndex: "gracePeriod",
      key: "gracePeriod",
      title: "Masa Tenggang",
      width: "5%",
    },
    // {
    //   dataIndex: "date",
    //   key: "date",
    //   title: "Tanggal Berlaku",
    //   width: "8%",
    //   render: (text) => (
    //     <div
    //       style={{
    //         color:
    //           text === "Kadaluarsa"
    //             ? "#EF5353"
    //             : text === "Aktif"
    //             ? "#56D453"
    //             : "#303030",
    //       }}
    //     >
    //       {text}
    //     </div>
    //   ),
    // },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "5%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_regular_offer}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
          {/* <CanAccess
            role={AuthorizationList.delete_campaign}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          /> */}
        </div>
      ),
    },
  ];
};

export const columnInstallment = (handleEdit) => {
  return [
    {
      dataIndex: "campaignName",
      key: "campaignName",
      title: "Nama Promo",
      backend_key: "name",
      sorter: true,
      width: "10%",
    },
    {
      dataIndex: "outlet",
      key: "outlet",
      title: "Outlet",
      width: "7%",
    },
    {
      dataIndex: "category",
      key: "category",
      title: "Kategori Produk",
      width: "7%",
    },
    {
      dataIndex: "paymentType",
      key: "paymentType",
      title: "Jenis Pembayaran",
      width: "6%",
    },
    {
      dataIndex: "tenorType",
      key: "tenorType",
      title: "Jenis Tenor",
      width: "5%",
    },
    {
      dataIndex: "periode",
      key: "periode",
      title: "Jumlah Periode",
      width: "6%",
    },
    {
      dataIndex: "dayPerPeriod",
      key: "dayPerPeriod",
      title: "Hari per Periode",
      width: "6%",
    },
    {
      dataIndex: "minLoan",
      key: "minLoan",
      title: "Minimum Pinjaman",
      width: "5%",
    },
    {
      dataIndex: "totalTenor",
      key: "totalTenor",
      title: "Total Tenor",
      width: "5%",
    },
    {
      dataIndex: "maxLoan",
      key: "maxLoan",
      title: "Loan to Value",
      width: "5%",
    },
    {
      dataIndex: "capitalLoan",
      key: "capitalLoan",
      title: "Biaya Sewa Modal",
      width: "5%",
    },
    {
      dataIndex: "feeAdminPercent",
      key: "feeAdminPercent",
      title: "Biaya Admin (%)",
      width: "5%",
    },
    {
      dataIndex: "feeAdminRupiah",
      key: "feeAdminRupiah",
      title: "Biaya Admin (Rp)",
      width: "5%",
    },
    {
      dataIndex: "feeSavingInsurance",
      key: "feeSavingInsurance",
      title: "Biaya Simpan & Asuransi",
      width: "6%",
    },
    {
      dataIndex: "lateCharge",
      key: "lateCharge",
      title: "Denda Harian",
      width: "5%",
    },
    {
      dataIndex: "lateChargePeriod",
      title: "Biaya Keterlambatan",
      width: "5%",
    },
    {
      dataIndex: "feeAuction",
      key: "feeAuction",
      title: "Biaya Jasa Lelang",
      width: "5%",
    },
    {
      dataIndex: "maxLate",
      key: "maxLate",
      title: "Maksimum Keterlambatan",
      width: "5%",
    },
    {
      dataIndex: "gracePeriod",
      key: "gracePeriod",
      title: "Masa Tenggang",
      width: "5%",
    },
    // {
    //   dataIndex: "gracePeriod",
    //   key: "gracePeriod",
    //   title: "Masa Tenggang",
    //   width: "5%",
    // },
    // {
    //   dataIndex: "date",
    //   key: "date",
    //   title: "Tanggal Berlaku",
    //   width: "8%",
    //   render: (text) => (
    //     <div
    //       style={{
    //         color:
    //           text === "Kadaluarsa"
    //             ? "#EF5353"
    //             : text === "Aktif"
    //             ? "#56D453"
    //             : "#303030",
    //       }}
    //     >
    //       {text}
    //     </div>
    //   ),
    // },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "5%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_regular_offer}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
          {/* <CanAccess
            role={AuthorizationList.delete_campaign}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          /> */}
        </div>
      ),
    },
  ];
};

export const columnExtension = (handleEdit, handleDelete) => {
  return [
    {
      dataIndex: "campaignName",
      key: "campaignName",
      title: "Nama Promo",
      backend_key: "name",
      sorter: true,
      width: "10%",
    },
    {
      dataIndex: "outlet",
      key: "outlet",
      title: "Outlet",
      width: "7%",
    },
    {
      dataIndex: "category",
      key: "category",
      title: "Kategori Produk",
      width: "7%",
    },
    {
      dataIndex: "paymentType",
      key: "paymentType",
      title: "Jenis Pembayaran",
      width: "6%",
    },
    {
      dataIndex: "tenorType",
      key: "tenorType",
      title: "Jenis Tenor",
      width: "5%",
    },
    {
      dataIndex: "tenorPerLoan",
      key: "tenorPerLoan",
      title: "Tenor Per Pinjaman",
      width: "5%",
    },
    {
      dataIndex: "minLoan",
      key: "minLoan",
      title: "Minimal Pinjaman",
      width: "5%",
    },
    {
      dataIndex: "maxLoan",
      key: "maxLoan",
      title: "Maksimal Pinjaman",
      width: "5%",
    },
    {
      dataIndex: "feeAdminPercent",
      key: "feeAdminPercent",
      title: "Biaya Admin (%)",
      width: "5%",
    },
    {
      dataIndex: "feeAdminRupiah",
      key: "feeAdminRupiah",
      title: "Biaya Admin (Rp)",
      width: "5%",
    },
    {
      dataIndex: "capitalLoan",
      key: "capitalLoan",
      title: "Biaya Sewa Modal",
      width: "5%",
    },
    {
      dataIndex: "feeSaving",
      key: "feeSaving",
      title: "Biaya Penyimpanan",
      width: "6%",
    },
    {
      dataIndex: "revaluasi",
      key: "revaluasi",
      title: "Nilai Revaluasi",
      width: "5%",
    },
    {
      dataIndex: "gracePeriod",
      key: "gracePeriod",
      title: "Masa Tenggang",
      width: "5%",
    },
    {
      dataIndex: "maxLate",
      key: "maxLate",
      title: "Maksimum Keterlambatan",
      width: "5%",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "5%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.update_regular_extension_offer}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
          {/* <CanAccess
            role={AuthorizationList.delete_campaign}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          /> */}
        </div>
      ),
    },
  ];
};
